import fetchRequest from './fetchRequest';
import { ObjectRequest, ObjectResponse } from './interfaces';

export default async function fetchForObject(
  request: ObjectRequest
): Promise<ObjectResponse> {
  return fetchRequest(request).then(resp => ({
    ...resp,
    request: request,
    objectId: request.objectId
  }));
}
